import { Box, Typography } from "@mui/material";
import { AlertBox } from "Components/Shared/AlertBox";
import { CheckboxInput } from "Components/Shared/Inputs/Form/CheckboxInput";
import { Resources, useResource } from "Translations/Resources";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

const ComponentResource = Resources.Onboarding.PoliticallyExposed;

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  isChecked: boolean;
};

export const PoliticallyExposedCheckbox = <
  FormType extends FieldValues,
  TransformedFieldValues extends object = FormType,
>({
  control,
  name,
  isChecked,
}: Props<FormType, TransformedFieldValues>) => {
  const { t } = useResource();

  return (
    <>
      <CheckboxInput
        label={t(ComponentResource.Title)}
        control={control}
        name={name}
        isLabelFirst
        isStrong
      />
      <Typography marginBottom={3}>
        {t(Resources.Components.Shared.PoliticallyExposedDescription)}
      </Typography>
      {!!isChecked && (
        <Box marginBottom={3}>
          <AlertBox>{t(ComponentResource.Alert)}</AlertBox>
        </Box>
      )}
    </>
  );
};
